import Action from "./Action";
import Location from "../Main/Location";
import {Serialization} from "../Main/Serializer";

export default class LocationChangeDescriptionAction implements Action {

    private readonly oldDescription: string;

    constructor(private location: Location, private newDescription: string) {
        this.oldDescription = this.location.getDescriptionMarkdown();
    }

    public apply() {
        this.location.setDescription(this.newDescription);
    }

    public revert() {
        this.location.setDescription(this.oldDescription);
    }

    public merge(newAction: Action): boolean {
        if (!(newAction instanceof LocationChangeDescriptionAction) || newAction.location !== this.location || newAction.oldDescription !== this.newDescription) {
            return false;
        }

        if ((this.newDescription.length > this.oldDescription.length) !== (newAction.newDescription.length > newAction.oldDescription.length)) {
            return false;
        }

        this.newDescription = newAction.newDescription;
        this.apply();

        return true;
    }

    public serializeForDebug(): Serialization {
        return {
            location: this.location.id,
            oldDescription: this.oldDescription,
            newDescription: this.newDescription,
        };
    }
}
